import { relations } from "drizzle-orm";
import { type AnyPgColumn, pgTable, uuid, uniqueIndex } from "drizzle-orm/pg-core";
import { user } from "../core/user.sql";
import { userProfile } from "../profile/profile.sql";
import { space } from "../space/space.sql";
import { mealPlanningSession } from "../../nutrition/meal-planning-session/meal-planning-session.sql";
import { exactlyOneOf, equalsOneOf } from "../../utils/sql";

export const scope = pgTable(
  "scope",
  {
    id: uuid("id").primaryKey(),
    userId: uuid("user_id").references(() => user.id),
    spaceId: uuid("space_id").references(() => space.id),
    mealPlanningSessionId: uuid("meal_planning_session_id").references(
      (): AnyPgColumn => mealPlanningSession.id,
    ),
  },
  (t) => [
    uniqueIndex("scope_user_id_idx").on(t.userId),
    uniqueIndex("scope_space_id_idx").on(t.spaceId),
    uniqueIndex("scope_meal_planning_session_id_idx").on(t.mealPlanningSessionId),
    exactlyOneOf("scope_exactly_one_owner", [t.userId, t.spaceId, t.mealPlanningSessionId]),
    equalsOneOf("scope_owner_matches_id", {
      value: t.id,
      columns: [t.userId, t.spaceId, t.mealPlanningSessionId],
    }),
  ],
);

export const scopeRelations = relations(scope, ({ one }) => ({
  space: one(space, {
    fields: [scope.spaceId],
    references: [space.id],
  }),
  userProfile: one(userProfile, {
    fields: [scope.userId],
    references: [userProfile.userId],
  }),
  mealPlanningSession: one(mealPlanningSession, {
    fields: [scope.mealPlanningSessionId],
    references: [mealPlanningSession.id],
  }),
}));
